<template>
  <div class="guide-container">
    <div class="row rounded mx-0 bg-secondary-3 p-3 align-items-center">
      <div class="col-12 col-md-7 mb-md-0 mb-2">
        <span class="font-weight-bold">{{ data.title }}</span>
        <p class="font-14 color-gray-6 mb-0 mt-1">{{ data.description }}</p>
      </div>
      <div class="col-12 col-md mb-md-0 mb-2 d-flex justify-content-end">
        <span
          v-if="data.documentId && data.documentId.length"
          class="custom-btn"
          @click="downloadGuideHandler"
        >
          <em class="fas fa-book" />
          Descargar guía(PDF)
        </span>
        <span
          v-if="data.videoUrl && data.videoUrl.length"
          class="custom-btn"
          @click="videoSelectedHandler"
        >
          <em class="fas fa-video" />
          Ver Video
        </span>
      </div>
      <div class="col-12 col-md-auto d-flex justify-content-end">
        <action-button
          variant="outline-success"
          i="fas fa-file-import"
          text="Entrar"
          @click="goToView"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActionButton from 'ActionButton';

export default {
  name: 'ResultRow',
  components: { ActionButton },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    goToView() {
      this.$emit('enter-clicked', this.data.id);
    },
    downloadGuideHandler() {
      this.$emit('download-guide', this.data.documentId);
    },
    videoSelectedHandler() {
      this.$emit('watch-video', this.data.videoUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables/_colors.scss';
.guide-container {
  .custom-btn {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 12px;
    border-radius: 50rem;
    border: 1px solid map-get($colors, 'gray-5');
    padding: 0.5rem 1.5rem;
    margin: auto 0.25rem;
    em {
      margin-right: 0.5rem;
      font-size: 1rem;
      color: map-get($colors, 'orange');
    }
  }
}
</style>
